// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import { ApiResponse, GroupRecord } from './types/types';

// Define a service using a base URL and expected endpoints
export const groupsAPI = createApi({
  reducerPath: 'groupsAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getGroups: builder.query<GroupRecord[], void>({
      query: () => ({
        url: `/auth/groups`,
        method: 'GET',
      }),
      transformResponse: (response: ApiResponse<GroupRecord[]>) => response.body,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetGroupsQuery } = groupsAPI;
